import { Component, Input, Output, EventEmitter, inject, OnInit, signal, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import moment, { Moment } from 'moment';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { MatDialog } from '@angular/material/dialog';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-service-commitment',
  imports: [
    MatInputModule,
    ReactiveFormsModule,
    MatIcon,
    MatCheckboxModule,
    MatDatepickerModule,
    MatRadioModule,
    MatButtonModule
  ],
  providers: [
    provideMomentDateAdapter(MY_FORMATS),
  ],
  templateUrl: './service-commitment.component.html',
  styleUrl: './service-commitment.component.scss'
})

export class ServiceCommitmentComponent implements OnInit {
  @Output() next = new EventEmitter<string[]>();

  @Input() formGroup!: FormGroup;
  @Input() serviceCommitmentdetails!: ViewNewRepApplication;
  @Input() viewattachments!: viewAttachements[];
  @Input() readonly = signal(false);
  @Output() preview = new EventEmitter<string[]>();
  attachment_servicecommitementrequired = signal(false);
  required = signal(false);
  daterequired = signal(false);
  readonly message = 'This field is required.';

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private snackBarService = inject(SnackbarService);
  status = 'Not Started';

  async ngOnInit() {
    this.formGroup.addControl('status', this.fb.control(''));
    this.formGroup.addControl('section', this.fb.control(''));
    this.formGroup.addControl('enlistment', this.fb.control(null));
    this.formGroup.addControl('ord', this.fb.control(null));
    this.formGroup.addControl('attachment_servicecommitement', this.fb.control([null]));
    this.formGroup.addControl('attachment_servicecommitementfileName', this.fb.control(''));

    await this.fetchServiceCommitment();
    this.handleFormStatus();
    this.handleservicecommitementChanges();
    this.handlestatusservicecommitementChanges();

  }

  fetchServiceCommitment(): void {
    this.formGroup.controls['status']?.setValue(this.serviceCommitmentdetails?.serviceStatus);
    this.formGroup.controls['section']?.setValue(this.serviceCommitmentdetails?.notApplicable);
    if (this.serviceCommitmentdetails?.enlistmentDate !== '1900-01-01T00:00:00Z') {
      this.formGroup.controls['enlistment']?.setValue(this.serviceCommitmentdetails?.enlistmentDate);
    }
    if (this.serviceCommitmentdetails?.ordDate !== '1900-01-01T00:00:00Z') {
      this.formGroup.controls['ord']?.setValue(this.serviceCommitmentdetails?.ordDate);
    }

    this.viewattachments.forEach(item => {
      if (item?.onboardingDocumentType === 'Attachement(NationalServie Commitment)') {
        this.formGroup.controls['attachment_servicecommitementfileName']?.setValue(item?.fileName);
      }
    })
    const anyFilled = Object.values(this.formGroup.value).some(v => v && v.toString().trim() !== '');
    if (!anyFilled) {
      this.status = 'Not Started';
      this.next.emit([this.status, 'submitted']);

    } else if (this.formGroup.valid) {
      const fileName = this.formGroup.get('attachment_servicecommitementfileName')?.value;

      if (['deferred', 'exempted'].includes(this.formGroup.get('status')?.value)) {
        if (fileName === null || fileName === undefined || fileName === '') {
          this.status = 'In Progress';
        } else {
          this.status = 'Completed';
        }
      } else {
        this.status = 'Completed';
      }
      this.next.emit([this.status, 'submitted']);
    } else {
      this.status = 'In Progress';
      this.next.emit([this.status, 'submitted']);
    }    
    if (this.readonly() == true) {
      this.formGroup?.disable();
    } else {
      this.formGroup?.enable();
    }
  }

  onAttachmentServiceCommitmentFileChange(event: any): void {
    const file = event.target.files?.[0];
    const fileControl = this.formGroup.get('attachment_servicecommitementfileName');

    if (file) {
      this.formGroup.patchValue({
        attachment_servicecommitement: file,
        attachment_servicecommitementfileName: file.name
      });
    }
    this.formGroup.controls['attachment_servicecommitementfileName'].markAsTouched();
    this.formGroup.controls['attachment_servicecommitementfileName'].updateValueAndValidity();
    if (!file) {
      fileControl?.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // ❌ Invalid type
    if (!allowedTypes.includes(file.type)) {
      fileControl?.setErrors({ invalidType: true });
      return;
    }

    // ❌ Invalid size
    if (file.size > maxSize) {
      fileControl?.setErrors({ maxSize: true });
      return;
    }

    // ✅ Valid file
    fileControl?.setErrors(null);
    // fileControl?.setValue(file);
    this.uploaddocument()

  }

  async uploaddocument() {
    const formData = new FormData();

    formData.append('file', this.formGroup.get('attachment_servicecommitement')?.value);
    formData.append('Description', 'Attachement(NationalServie Commitment)');
    formData.append('filename', this.formGroup.get('attachment_servicecommitement')?.value?.name);
    formData.append('ResponseValue', '');

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formGroup.patchValue({
        attachment_servicecommitementfileName: responseData.data.responsedata
      });
      this.viewDocumants();
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  removeFile(controlName: string, fileVar: string, categoryname: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    this.viewDocumants();
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let onboardingId;
          let id;
          let docTypeId;
          this.viewattachments.forEach(item => {
            if (item?.onboardingDocumentType === categoryname) {
              onboardingId = item.onboardingId;
              docTypeId = item.docTypeId;
              id = item.id
            }
          })

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          const responseData = await this.newRepApplicationService
            .deletedocument(data)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
        }
        this.formGroup.get(controlName)?.reset();
        this.formGroup.get(fileVar)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.formGroup.controls[controlName].markAsTouched();
        this.formGroup.controls[controlName].updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });
  }

  async viewDocumants() {
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(this.serviceCommitmentdetails?.id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }


  setenlistmentMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = moment(this.formGroup.get('enlistment')?.value || new Date());
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    this.formGroup.get('enlistment')?.setValue(ctrlValue);
    datepicker.close();
  }

  setordMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = moment(this.formGroup.get('ord')?.value || new Date());
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    this.formGroup.get('ord')?.setValue(ctrlValue);
    datepicker.close();
  }

  handleservicecommitementChanges() {
    const section = this.formGroup.get('section');

    const status = this.formGroup.get('status');
    const enlistment = this.formGroup.get('enlistment');
    const ord = this.formGroup.get('ord');
    const attachment_servicecommitement = this.formGroup.get('attachment_servicecommitement');
    const attachment_servicecommitementfileName = this.formGroup.get('attachment_servicecommitementfileName');

    section?.valueChanges.subscribe(value => {
      if (value === false) {

        status?.setValidators([Validators.required]);

      } else {
        status?.clearValidators();
        attachment_servicecommitement?.clearValidators();
        attachment_servicecommitementfileName?.clearValidators();
        enlistment?.clearValidators();
        ord?.clearValidators();
        attachment_servicecommitementfileName?.reset();
        status?.reset();
        attachment_servicecommitement?.reset();
        enlistment?.reset();
        ord?.reset();

      }


      // Update all affected controls once
      [status, enlistment, ord].forEach(ctrl =>
        ctrl?.updateValueAndValidity()
      );
    });
  }

  handlestatusservicecommitementChanges() {
    const status = this.formGroup.get('status');
    const enlistment = this.formGroup.get('enlistment');
    const ord = this.formGroup.get('ord');
    const attachment_servicecommitement = this.formGroup.get('attachment_servicecommitement');
    const attachment_servicecommitementfileName = this.formGroup.get('attachment_servicecommitementfileName');

    status?.valueChanges.subscribe(value => {
      if (value === 'completed') {

        enlistment?.setValidators([Validators.required]);
        ord?.setValidators([Validators.required]);
        attachment_servicecommitementfileName?.clearValidators();
        attachment_servicecommitementfileName?.reset();
        attachment_servicecommitement?.reset();

      } else if (value === 'deferred' || value === 'exempted') {

        attachment_servicecommitementfileName?.setValidators([Validators.required]);
        enlistment?.clearValidators();
        ord?.clearValidators();
        enlistment?.reset();
        ord?.reset();

      }


      // Update all affected controls once
      [enlistment, ord, attachment_servicecommitementfileName, attachment_servicecommitement].forEach(ctrl =>
        ctrl?.updateValueAndValidity()
      );
    });
  }

  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }


  saveAndContinue() {

    // Validation or API save logic here
    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';

    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);
  }

  previewAttachment(controlName: string, categoryName: string) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === categoryName) {
          id = item.id;
        }
      });
      let filename = this.formGroup.get(controlName)?.value;
      this.preview.emit([id, filename]);
    }
  }

}
